import React from 'react';
import ServicePage from '../components/ServicePage';
import heroBillede from '../images/JordvarmeHero.jpg';
import decLogo from '../images/decas-logo-cmyk-pos-adr.jpg';

function Jordvarme() {
  return (
    <ServicePage
      slug="jordvarme"
      path="/jordvarme"
      navn="Jordvarme"
      seo={{
        title: 'Jordvarme i Holbæk & på Sjælland | JBC Entreprenøren',
        description: 'Jordvarme i Holbæk og på hele Sjælland i samarbejde med Dansk Energi Center. Energieffektiv opvarmning – få et gratis tilbud fra lokale specialister.',
        image: 'https://jbcentreprenoeren.dk/images/og-jordvarme.jpg',
        serviceName: 'Jordvarme installation',
      }}
      hero={{
        titel: 'Jordvarme installation',
        tekst: 'Din lokale jordvarme-specialist med solid forankring i Nordvestsjælland. Vi installerer energieffektive jordvarmeanlæg for kunder på hele Sjælland.',
        cta: 'Få tilbud på jordvarme',
        billede: heroBillede,
        billedeAlt: 'Gravet rende med jordvarmeslanger lagt ned',
      }}
      intro={{
        titel: 'Professionel jordvarme installation',
        tekst: [
          'JBC Entreprenøren laver jordvarme i Holbæk, Tølløse, Roskilde, Odsherred og resten af Sjælland. Vi samarbejder med Dansk Energi Center, som står for det hele – lige fra udregningerne til installationen af selve anlægget.',
          'Med vores lokale kendskab til området omkring Holbæk sørger vi for, at gravearbejdet og nedlægningen af slanger bliver gjort ordentligt.',
        ],
      }}
      ekstra={(
        <a className="tj-partner" href="https://dansk-energi-center.dk/" target="_blank" rel="noopener noreferrer">
          <img src={decLogo} alt="Dansk Energi Center" />
          <span>
            <strong>I samarbejde med Dansk Energi Center</strong>
            Beregning og installation af jordvarmeanlæg
          </span>
        </a>
      )}
      ydelser={{
        titel: 'Fordele ved jordvarme',
        punkter: [
          'Energibesparelse på op til 50% sammenlignet med traditionel opvarmning',
          'Miljøvenlig opvarmning med lav CO₂-udledning',
          'Ingen løbende vedligeholdelse af kedel eller brænder',
          'Konstant og behagelig varme i hele huset',
          'Øget ejendomsværdi',
        ],
      }}
      fordele={{
        titel: 'Jordvarme gjort ordentligt',
        punkter: [
          'Lokalt kendskab til jordbunden',
          'Samarbejde med Dansk Energi Center',
          'Løsning tilpasset dit hjem',
          'Gratis og uforpligtende tilbud',
        ],
      }}
      kontaktTekst="Skal du have jordvarme? Vi hjælper gerne med dit projekt."
    />
  );
}

export default Jordvarme;
